import { render, staticRenderFns } from "./UidTokenGuidePopupAuto.vue?vue&type=template&id=f1811cf0&scoped=true&"
import script from "./UidTokenGuidePopupAuto.vue?vue&type=script&lang=js&"
export * from "./UidTokenGuidePopupAuto.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenGuidePopupAuto.vue?vue&type=style&index=0&id=f1811cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1811cf0",
  null
  
)

export default component.exports